/* Piece Verse product page: shipping estimate dates and mobile sticky add-to-cart. */

if (!customElements.get('bk-ship-estimate')) {
  customElements.define(
    'bk-ship-estimate',
    class BkShipEstimate extends HTMLElement {
      static addBusinessDays(start, days) {
        const date = new Date(start.getTime());
        let remaining = days;
        while (remaining > 0) {
          date.setDate(date.getDate() + 1);
          const day = date.getDay();
          if (day !== 0 && day !== 6) remaining -= 1;
        }
        return date;
      }

      connectedCallback() {
        const min = parseInt(this.dataset.min, 10);
        const max = parseInt(this.dataset.max, 10);
        const eta = this.querySelector('[data-bk-ship-eta]');
        const range = this.querySelector('[data-bk-ship-range]');
        if (!eta || !range || !Number.isFinite(min) || !Number.isFinite(max) || min < 0 || max < min) return;

        const format = new Intl.DateTimeFormat('en-US', { month: 'short', day: 'numeric' });
        const today = new Date();
        const from = BkShipEstimate.addBusinessDays(today, min);
        const to = BkShipEstimate.addBusinessDays(today, max);
        range.textContent = `${format.format(from)} to ${format.format(to)}`;
        eta.hidden = false;
      }
    }
  );
}

if (!customElements.get('bk-sticky-atc')) {
  customElements.define(
    'bk-sticky-atc',
    class BkStickyAtc extends HTMLElement {
      connectedCallback() {
        const section = this.dataset.section;
        this.main = document.getElementById(`ProductSubmitButton-${section}`);
        this.button = this.querySelector('[data-bk-sticky-btn]');
        this.price = this.querySelector('[data-bk-sticky-price]');
        if (!this.main || !this.button) return;

        this.button.addEventListener('click', () => {
          if (!this.main.disabled) this.main.click();
        });

        this.observer = new IntersectionObserver(
          ([entry]) => {
            // Show only once the main button has scrolled off the top of the viewport.
            this.hidden = !(!entry.isIntersecting && entry.boundingClientRect.top < 0);
            document.body.classList.toggle('bk-has-sticky', !this.hidden);
          },
          { threshold: 0 }
        );
        this.observer.observe(this.main);

        this.sync = this.sync.bind(this);
        this.mutations = new MutationObserver(this.sync);
        this.mutations.observe(this.main, { attributes: true, childList: true, subtree: true, characterData: true });
        const priceNode = document.getElementById(`price-${section}`);
        if (priceNode) this.mutations.observe(priceNode, { childList: true, subtree: true, characterData: true });
        this.sync();
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        document.body.classList.remove('bk-has-sticky');
        this.mutations?.disconnect();
      }

      sync() {
        const label = this.main.querySelector('span');
        if (label) this.button.textContent = label.textContent.trim();
        this.button.disabled = this.main.disabled;
        const now = document.querySelector(`#price-${this.dataset.section} .bk-pdp-price__now`);
        if (now && this.price) this.price.textContent = now.textContent.trim();
      }
    }
  );
}

/* Urgency: the holiday order-by line shows the real number of days left until the date set in theme settings
   and hides itself once that date has passed. Computed from the visitor's clock, so cached pages never show a
   stale count. */
(function () {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  document.querySelectorAll('[data-bk-deadline]').forEach((line) => {
    const parts = (line.dataset.bkDeadline || '').split('-').map(Number);
    if (parts.length !== 3 || parts.some(Number.isNaN)) return;
    const deadline = new Date(parts[0], parts[1] - 1, parts[2]);
    const days = Math.round((deadline - today) / 86400000);
    if (days < 0) return;
    const count = line.querySelector('[data-bk-days-left]');
    if (count) {
      if (days === 0) count.textContent = count.dataset.today;
      else if (days === 1) count.textContent = count.dataset.one;
      else count.textContent = (count.dataset.other || '').replace('[n]', days);
    }
    line.hidden = false;
  });
})();
